module.exports = __webpack_public_path__ + "img/7.24f0f7c2.jpg";